var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"payment-grid\"></div>\r\n\r\n<p class=\"total\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"totalLabel") || (depth0 != null ? lookupProperty(depth0,"totalLabel") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"totalLabel","hash":{},"data":data,"loc":{"start":{"line":22,"column":17},"end":{"line":22,"column":31}}}) : helper)))
    + " $<span class=\"amount\">0.00</span></p>";
},"useData":true});